<template>
  <NrIconButton
    class="show-more-ellipsis"
    size="small"
    variant="minimal-primary"
    ref="trigger"
    aria-label="Show more line item actions"
    :icon="{ name: 'ellipsis-v' }"
  />

  <div class="show-more-dropdown" v-show="show" ref="dropdown">
    <div aria-role="listitem" class="show-more-dropdown-item">
      <NrButton
        size="small"
        variant="minimal-primary"
        @click="$emit('on-edit')"
      >
        <NrIcon name="pencil-alt" />
        <span>Edit</span>
      </NrButton>
    </div>

    <div aria-role="listitem" class="show-more-dropdown-item">
      <NrButton
        size="small"
        variant="minimal-primary"
        @click="$emit('on-delete')"
      >
        <NrIcon name="trash-alt" />
        <span>Delete</span>
      </NrButton>
    </div>
  </div>
</template>
<script lang="ts">
import NrButton from '@nextrequestco/components/src/components/NrButton'
import NrIcon from '@nextrequestco/components/src/components/NrIcon'
import NrIconButton from '@nextrequestco/components/src/components/NrIconButton'
import { createPopper } from '@popperjs/core/lib/popper-lite'

export default {
  components: {
    NrButton,
    NrIcon,
    NrIconButton
  },

  data() {
    return { popper: null, show: false }
  },

  mounted() {
    this.popper = createPopper(this.$refs.trigger.$el, this.$refs.dropdown, {
      strategy: 'fixed',
      placement: 'left-start'
    })
    document.addEventListener('click', this.handleClick)
  },

  methods: {
    handleClick(event: Event): void {
      // Bind a click event to the DOM to track when the ellipsis button is clicked to open or close the menu
      // Also tracks when you click anywhere outside the button to close the menu
      const el = event.target
      const button = this.$refs.trigger.$el

      if (button.contains(el)) {
        this.show = !this.show
      } else {
        this.show = false
      }
    }
  },

  updated() {
    this.popper?.update()
  },

  beforeUnmount() {
    this.popper?.destroy()
    document.removeEventListener('click', this.handleClick)
  }
}
</script>
<style lang="scss">
@import '@nextrequestco/components/src/styles/tokens/variables.scss';

.show-more-ellipsis {
  fill: $color-blue-100;
}

.show-more-dropdown {
  background: white;
  position: fixed;
  z-index: 2;
  right: 64px;
  border: 1px solid #d8d8df;
  border-radius: $border-radius-default;
  width: 80px;
  .show-more-dropdown-item {
    .nr-button {
      display: flex;
      text-decoration: none;
      .nr-icon {
        margin-right: $spacing-6;
        margin-top: 2px;
      }
    }
  }
}
</style>
